import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { selectIsMaintenanceActive, selectMaintenanceData, selectMaintenanceDetails, selectMaintenanceError, selectMaintenanceLoading } from "../../store/reducers/maintenanceSlice";
import { fetchMaintenance } from "../../store/actions/maintenanceActions";


export const useMaintenance = () => {
  const dispatch = useDispatch();

  const maintenance = useSelector(selectMaintenanceData);
  const loading = useSelector(selectMaintenanceLoading);
  const error = useSelector(selectMaintenanceError);
  const isActive = useSelector(selectIsMaintenanceActive);
  const details = useSelector(selectMaintenanceDetails);

  const loadMaintenance = useCallback(() => {
    dispatch(fetchMaintenance());
  }, [dispatch]);

  return {
    maintenance,   
    details,       
    isActive,     
    loading,
    error,
    loadMaintenance,
  };
};
